<template>
  <bvue-ui-view class="flex flex-col">
    <div class="flex items-center">
      <h1>Asignación de Semillas</h1>
    </div>
    <h4 class="mt-2"><label>Ingresa la ID del Usuario</label></h4>
    <input type="text" class="form-input mb-4" v-model="assigndata.userid">
    <h4><label>Cantidad de Semillas a asignar</label></h4>
    <input type="number" class="form-input mb-4" :min="1" v-model="assigndata.numberseeds">
    <h4 class="mt-2"><label>Reserva</label></h4>
    <select name="ecosystem" class="form-select" v-model="assigndata.reserva">
      <option v-for="ecosystem in ecosystems" :value="ecosystem.id" :key="ecosystem.id">
        {{ ecosystem.name }}
      </option>
    </select>
    <div class="w-full flex items-center justify-center mt-6">
      <button class="btn btn-primary w-full" @click="assignSeeds">Asignar Semillas</button>
    </div>
  </bvue-ui-view>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import firebase from '@/firebase'
import swal from 'sweetalert';


export default {
  name: 'Seeds',
  props: {
    modalData: Object,
      required: true,
  },
  data() {
    return {
      assigndata: {
      userid: '',
      numberseeds: '1',
      reserva: ''
      }
   }
  },
  computed: {
    ecosystems() {
     // const ecosystems = this.$store.getters.activeReserves
     let ecosystems = this.$store.state.reserves.items
      return ecosystems
    }
  },
  methods: {
   async assignSeeds(){
     var currentDate = new Date().getTime();
      const response = await this.$dialogs.alert('¿Está seguro de la acción? Se asignarán nuevas semillas', {title: 'Estás seguro', okLabel: 'Asignar'} )
      if(response.ok){
          if(this.assigndata.reserva != '' && this.assigndata.userid != ''){
          //seeds = firebase.firestore.collection('reserves').doc(this.assigndata.reserva).collection('seeds')
          //seeds.push(firebase.firestore.collection('reserves').doc(this.assigndata.reserva).active)
            var semillas = []
            semillas = this.$store.getters.reserveUnplantedSeedsTunel(this.assigndata.reserva,this.assigndata.numberseeds)

            for(let i =0;i<this.assigndata.numberseeds;i++){
            firebase.firestore.collection('reserves').doc(this.assigndata.reserva).collection('seeds').doc(semillas[i].id).update({ownerId: this.assigndata.userid, assignDate: currentDate})
            }
          //console.log('got this', semillas)
            }else swal('¡Advertencia!','¡Debes llenas todos los campos!')
      }
    }
  }
}

</script>



<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/AssignSeeds.vue